var BDVar = {}
export{
	BDVar
}